import Classroom from "../../../../interfaces/Classroom";
import ClassroomAssignmentDetails from "../../../../interfaces/ClassroomAssignmentDetails";
import ReadleeProfile from "../../../../services/firebase/ReadleeProfile";
import AssignmentOnTeacher from "../../../../state/teacherData/AssignmentOnTeacher";

interface Students {
  [key: string]: ReadleeProfile;
}

interface Assignments {
  [key: string]: AssignmentOnTeacher;
}

interface AssignmentClasses {
  [key: string]: {
    [key: string]: ClassroomAssignmentDetails;
  };
}

export const filterStudents = (classroom: Classroom, students: Students) =>
  !classroom?.students
    ? {}
    : Object.entries(students).reduce(
        (acc, [key, student]) => (classroom.students[key] ? { ...acc, [key]: student } : acc),
        {},
      );

const paramOptions = ["starred", "shared", "archived"];
// Returns true if filterBy param in the url is valid
export const checkFilterByParam = (filterBy?: string | string[] | null) =>
  typeof filterBy === "string" ? paramOptions.includes(filterBy) : false;

export const findClassroom = (classrooms: Classroom[], id: string) => classrooms.find(classroom => classroom.id === id);

const isActive = (assignment: AssignmentOnTeacher) => assignment.assignmentDetails.isActive;

export const filterAssignmentsFunc =
  (
    assignments: Assignments,
    assignmentClasses: AssignmentClasses,
    starredAssignments: string[],
    profile?: ReadleeProfile,
  ) =>
  (filterBy?: string, classIdURL?: string) => {
    const getActive = filterBy !== "archived";
    let assignmentsToBeFiltered = Object.values(assignments).filter(assignment => isActive(assignment) === getActive);
    if (classIdURL)
      assignmentsToBeFiltered = assignmentsToBeFiltered.filter(
        assignment => assignmentClasses[assignment.id]?.[classIdURL],
      );

    if (!assignmentsToBeFiltered?.length) return [];

    switch (filterBy) {
      case "starred":
        return assignmentsToBeFiltered.filter(assignment => starredAssignments.includes(assignment.id));
      case "shared":
        return assignmentsToBeFiltered.filter(assignment => assignment.assignmentDetails.parentId !== profile?.uid);
      //  "all" covers old routes. remove when they are removed
      // undefined covers new teacher student and assignment summary page routes
      case "all":
      case undefined:
      case "archived":
        return assignmentsToBeFiltered;
      default:
        return [];
    }
  };
